// src/api.ts
import globalAxios2 from "axios";

// src/base.ts
import globalAxios from "axios";
var BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");
var BaseAPI = class {
  constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
    this.basePath = basePath;
    this.axios = axios;
    var _a;
    if (configuration) {
      this.configuration = configuration;
      this.basePath = (_a = configuration.basePath) != null ? _a : basePath;
    }
  }
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = "RequiredError";
  }
};
var operationServerMap = {};

// src/common.ts
var DUMMY_BASE_URL = "https://example.com";
var assertParamExists = function(functionName, paramName, paramValue) {
  if (paramValue === null || paramValue === void 0) {
    throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
  }
};
function setFlattenedQueryParams(urlSearchParams, parameter, key = "") {
  if (parameter == null)
    return;
  if (typeof parameter === "object") {
    if (Array.isArray(parameter)) {
      parameter.forEach((item) => setFlattenedQueryParams(urlSearchParams, item, key));
    } else {
      Object.keys(parameter).forEach(
        (currentKey) => setFlattenedQueryParams(urlSearchParams, parameter[currentKey], `${key}${key !== "" ? "." : ""}${currentKey}`)
      );
    }
  } else {
    if (urlSearchParams.has(key)) {
      urlSearchParams.append(key, parameter);
    } else {
      urlSearchParams.set(key, parameter);
    }
  }
}
var setSearchParams = function(url, ...objects) {
  const searchParams = new URLSearchParams(url.search);
  setFlattenedQueryParams(searchParams, objects);
  url.search = searchParams.toString();
};
var serializeDataIfNeeded = function(value, requestOptions, configuration) {
  const nonString = typeof value !== "string";
  const needsSerialization = nonString && configuration && configuration.isJsonMime ? configuration.isJsonMime(requestOptions.headers["Content-Type"]) : nonString;
  return needsSerialization ? JSON.stringify(value !== void 0 ? value : {}) : value || "";
};
var toPathString = function(url) {
  return url.pathname + url.search + url.hash;
};
var createRequestFunction = function(axiosArgs, globalAxios3, BASE_PATH2, configuration) {
  return (axios = globalAxios3, basePath = BASE_PATH2) => {
    var _a;
    const axiosRequestArgs = { ...axiosArgs.options, url: (axios.defaults.baseURL ? "" : (_a = configuration == null ? void 0 : configuration.basePath) != null ? _a : basePath) + axiosArgs.url };
    return axios.request(axiosRequestArgs);
  };
};

// src/api.ts
var AccessControlTypeEnum = {
  AllowAll: "ALLOW_ALL",
  RestrictedMembers: "RESTRICTED_MEMBERS",
  CreatorOnly: "CREATOR_ONLY"
};
var CampaignDTORoleEnum = {
  SuperAdmin: "SUPER_ADMIN",
  Admin: "ADMIN",
  Author: "AUTHOR",
  Member: "MEMBER"
};
var CampaignDTOActionsEnum = {
  View: "VIEW",
  Manage: "MANAGE",
  ViewMembers: "VIEW_MEMBERS",
  AddMember: "ADD_MEMBER",
  UpdateMember: "UPDATE_MEMBER",
  RemoveMember: "REMOVE_MEMBER"
};
var CampaignInviteDTORoleEnum = {
  SuperAdmin: "SUPER_ADMIN",
  Admin: "ADMIN",
  Author: "AUTHOR",
  Member: "MEMBER"
};
var ComponentTypeEnum = {
  Image: "IMAGE",
  QuestLog: "QUEST_LOG",
  Markdown: "MARKDOWN",
  Character: "CHARACTER",
  Unknown: "UNKNOWN"
};
var ContentComponentDTOTypeEnum = {
  Image: "IMAGE",
  QuestLog: "QUEST_LOG",
  Markdown: "MARKDOWN",
  Character: "CHARACTER",
  Unknown: "UNKNOWN"
};
var ContentDTOActionsEnum = {
  Create: "CREATE",
  View: "VIEW",
  Update: "UPDATE",
  Delete: "DELETE"
};
var ContentDTOContentCategoryEnum = {
  Picture: "PICTURE",
  Map: "MAP",
  Lore: "LORE",
  Quest: "QUEST",
  Character: "CHARACTER",
  Npc: "NPC",
  Item: "ITEM",
  Timeline: "TIMELINE",
  SessionNotes: "SESSION_NOTES"
};
var ContentPreviewDTOContentCategoryEnum = {
  Picture: "PICTURE",
  Map: "MAP",
  Lore: "LORE",
  Quest: "QUEST",
  Character: "CHARACTER",
  Npc: "NPC",
  Item: "ITEM",
  Timeline: "TIMELINE",
  SessionNotes: "SESSION_NOTES"
};
var ContentRequestContentCategoryEnum = {
  Picture: "PICTURE",
  Map: "MAP",
  Lore: "LORE",
  Quest: "QUEST",
  Character: "CHARACTER",
  Npc: "NPC",
  Item: "ITEM",
  Timeline: "TIMELINE",
  SessionNotes: "SESSION_NOTES"
};
var GenerateInviteLinkRequestRoleEnum = {
  SuperAdmin: "SUPER_ADMIN",
  Admin: "ADMIN",
  Author: "AUTHOR",
  Member: "MEMBER"
};
var LimitedProfileDTORoleEnum = {
  SuperAdmin: "SUPER_ADMIN",
  Admin: "ADMIN",
  Author: "AUTHOR",
  Member: "MEMBER"
};
var LinkInfoTypeEnum = {
  IntraContent: "INTRA_CONTENT",
  InterContent: "INTER_CONTENT"
};
var MembershipRequestRoleEnum = {
  SuperAdmin: "SUPER_ADMIN",
  Admin: "ADMIN",
  Author: "AUTHOR",
  Member: "MEMBER"
};
var ProfileDTOTierEnum = {
  Free: "FREE",
  IndividualPremium: "INDIVIDUAL_PREMIUM",
  PremiumSharing: "PREMIUM_SHARING",
  YagTier: "YAG_TIER"
};
var ProfileDTORolesEnum = {
  SuperAdmin: "SUPER_ADMIN",
  Admin: "ADMIN",
  Author: "AUTHOR",
  Member: "MEMBER"
};
var QuestDTOStatusEnum = {
  Active: "ACTIVE",
  Completed: "COMPLETED",
  Failed: "FAILED"
};
var CampaignControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {SaveCampaignRequest} saveCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCampaign: async (saveCampaignRequest, options = {}) => {
      assertParamExists("createCampaign", "saveCampaignRequest", saveCampaignRequest);
      const localVarPath = `/campaign/`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(saveCampaignRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCampaign: async (campaignId, options = {}) => {
      assertParamExists("getCampaign", "campaignId", campaignId);
      const localVarPath = `/campaign/{campaignId}`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCampaignMembers: async (campaignId, options = {}) => {
      assertParamExists("getCampaignMembers", "campaignId", campaignId);
      const localVarPath = `/campaign/{campaignId}/members`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} inviteLinkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLimitedCampaignInfo: async (campaignId, inviteLinkId, options = {}) => {
      assertParamExists("getLimitedCampaignInfo", "campaignId", campaignId);
      assertParamExists("getLimitedCampaignInfo", "inviteLinkId", inviteLinkId);
      const localVarPath = `/campaign/{campaignId}/invite/{inviteLinkId}`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId))).replace(`{${"inviteLinkId"}}`, encodeURIComponent(String(inviteLinkId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuests: async (campaignId, options = {}) => {
      assertParamExists("getQuests", "campaignId", campaignId);
      const localVarPath = `/campaign/{campaignId}/quests`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCampaigns: async (options = {}) => {
      const localVarPath = `/campaign/`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} id 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeCampaignMember: async (id, memberId, options = {}) => {
      assertParamExists("removeCampaignMember", "id", id);
      assertParamExists("removeCampaignMember", "memberId", memberId);
      const localVarPath = `/campaign/{id}/members/{memberId}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {SaveCampaignRequest} saveCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCampaign: async (campaignId, saveCampaignRequest, options = {}) => {
      assertParamExists("updateCampaign", "campaignId", campaignId);
      assertParamExists("updateCampaign", "saveCampaignRequest", saveCampaignRequest);
      const localVarPath = `/campaign/{campaignId}`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(saveCampaignRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} id 
     * @param {MembershipRequest} membershipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCampaignMember: async (id, membershipRequest, options = {}) => {
      assertParamExists("updateCampaignMember", "id", id);
      assertParamExists("updateCampaignMember", "membershipRequest", membershipRequest);
      const localVarPath = `/campaign/{id}/members`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(membershipRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
var CampaignControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = CampaignControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {SaveCampaignRequest} saveCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCampaign(saveCampaignRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.createCampaign(saveCampaignRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.createCampaign"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCampaign(campaignId, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaign(campaignId, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.getCampaign"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCampaignMembers(campaignId, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignMembers(campaignId, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.getCampaignMembers"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} inviteLinkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLimitedCampaignInfo(campaignId, inviteLinkId, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLimitedCampaignInfo(campaignId, inviteLinkId, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.getLimitedCampaignInfo"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getQuests(campaignId, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.getQuests(campaignId, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.getQuests"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCampaigns(options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCampaigns(options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.listCampaigns"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} id 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeCampaignMember(id, memberId, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.removeCampaignMember(id, memberId, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.removeCampaignMember"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {SaveCampaignRequest} saveCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCampaign(campaignId, saveCampaignRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCampaign(campaignId, saveCampaignRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.updateCampaign"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} id 
     * @param {MembershipRequest} membershipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCampaignMember(id, membershipRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCampaignMember(id, membershipRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["CampaignControllerApi.updateCampaignMember"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    }
  };
};
var CampaignControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = CampaignControllerApiFp(configuration);
  return {
    /**
     * 
     * @param {SaveCampaignRequest} saveCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCampaign(saveCampaignRequest, options) {
      return localVarFp.createCampaign(saveCampaignRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCampaign(campaignId, options) {
      return localVarFp.getCampaign(campaignId, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCampaignMembers(campaignId, options) {
      return localVarFp.getCampaignMembers(campaignId, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} inviteLinkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLimitedCampaignInfo(campaignId, inviteLinkId, options) {
      return localVarFp.getLimitedCampaignInfo(campaignId, inviteLinkId, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuests(campaignId, options) {
      return localVarFp.getQuests(campaignId, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCampaigns(options) {
      return localVarFp.listCampaigns(options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} id 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeCampaignMember(id, memberId, options) {
      return localVarFp.removeCampaignMember(id, memberId, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {SaveCampaignRequest} saveCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCampaign(campaignId, saveCampaignRequest, options) {
      return localVarFp.updateCampaign(campaignId, saveCampaignRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} id 
     * @param {MembershipRequest} membershipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCampaignMember(id, membershipRequest, options) {
      return localVarFp.updateCampaignMember(id, membershipRequest, options).then((request) => request(axios, basePath));
    }
  };
};
var CampaignControllerApi = class extends BaseAPI {
  /**
   * 
   * @param {SaveCampaignRequest} saveCampaignRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  createCampaign(saveCampaignRequest, options) {
    return CampaignControllerApiFp(this.configuration).createCampaign(saveCampaignRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  getCampaign(campaignId, options) {
    return CampaignControllerApiFp(this.configuration).getCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  getCampaignMembers(campaignId, options) {
    return CampaignControllerApiFp(this.configuration).getCampaignMembers(campaignId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {string} inviteLinkId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  getLimitedCampaignInfo(campaignId, inviteLinkId, options) {
    return CampaignControllerApiFp(this.configuration).getLimitedCampaignInfo(campaignId, inviteLinkId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  getQuests(campaignId, options) {
    return CampaignControllerApiFp(this.configuration).getQuests(campaignId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  listCampaigns(options) {
    return CampaignControllerApiFp(this.configuration).listCampaigns(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} id 
   * @param {string} memberId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  removeCampaignMember(id, memberId, options) {
    return CampaignControllerApiFp(this.configuration).removeCampaignMember(id, memberId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {SaveCampaignRequest} saveCampaignRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  updateCampaign(campaignId, saveCampaignRequest, options) {
    return CampaignControllerApiFp(this.configuration).updateCampaign(campaignId, saveCampaignRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} id 
   * @param {MembershipRequest} membershipRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignControllerApi
   */
  updateCampaignMember(id, membershipRequest, options) {
    return CampaignControllerApiFp(this.configuration).updateCampaignMember(id, membershipRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var ContentControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {string} campaignId 
     * @param {ContentRequest} contentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createContent: async (campaignId, contentRequest, options = {}) => {
      assertParamExists("createContent", "campaignId", campaignId);
      assertParamExists("createContent", "contentRequest", contentRequest);
      const localVarPath = `/campaign/{campaignId}/content`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(contentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {string} componentReference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComponent: async (campaignId, contentId, componentReference, options = {}) => {
      assertParamExists("deleteComponent", "campaignId", campaignId);
      assertParamExists("deleteComponent", "contentId", contentId);
      assertParamExists("deleteComponent", "componentReference", componentReference);
      const localVarPath = `/campaign/{campaignId}/content/{contentId}/{componentReference}`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId))).replace(`{${"contentId"}}`, encodeURIComponent(String(contentId))).replace(`{${"componentReference"}}`, encodeURIComponent(String(componentReference)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteContent: async (campaignId, contentId, options = {}) => {
      assertParamExists("deleteContent", "campaignId", campaignId);
      assertParamExists("deleteContent", "contentId", contentId);
      const localVarPath = `/campaign/{campaignId}/content/{contentId}`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId))).replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContent: async (campaignId, contentId, options = {}) => {
      assertParamExists("getContent", "campaignId", campaignId);
      assertParamExists("getContent", "contentId", contentId);
      const localVarPath = `/campaign/{campaignId}/content/{contentId}`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId))).replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} [lastEvaluatedKey] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContents: async (campaignId, lastEvaluatedKey, limit, options = {}) => {
      assertParamExists("listContents", "campaignId", campaignId);
      const localVarPath = `/campaign/{campaignId}/content`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (lastEvaluatedKey !== void 0) {
        localVarQueryParameter["lastEvaluatedKey"] = lastEvaluatedKey;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {ComponentRequest} componentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateComponent: async (campaignId, contentId, componentRequest, options = {}) => {
      assertParamExists("updateComponent", "campaignId", campaignId);
      assertParamExists("updateComponent", "contentId", contentId);
      assertParamExists("updateComponent", "componentRequest", componentRequest);
      const localVarPath = `/campaign/{campaignId}/content/{contentId}/component`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId))).replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(componentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {ContentRequest} contentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContent: async (campaignId, contentId, contentRequest, options = {}) => {
      assertParamExists("updateContent", "campaignId", campaignId);
      assertParamExists("updateContent", "contentId", contentId);
      assertParamExists("updateContent", "contentRequest", contentRequest);
      const localVarPath = `/campaign/{campaignId}/content/{contentId}`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId))).replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(contentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
var ContentControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = ContentControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {string} campaignId 
     * @param {ContentRequest} contentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createContent(campaignId, contentRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.createContent(campaignId, contentRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ContentControllerApi.createContent"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {string} componentReference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteComponent(campaignId, contentId, componentReference, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComponent(campaignId, contentId, componentReference, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ContentControllerApi.deleteComponent"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteContent(campaignId, contentId, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContent(campaignId, contentId, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ContentControllerApi.deleteContent"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContent(campaignId, contentId, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.getContent(campaignId, contentId, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ContentControllerApi.getContent"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} [lastEvaluatedKey] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listContents(campaignId, lastEvaluatedKey, limit, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.listContents(campaignId, lastEvaluatedKey, limit, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ContentControllerApi.listContents"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {ComponentRequest} componentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateComponent(campaignId, contentId, componentRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateComponent(campaignId, contentId, componentRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ContentControllerApi.updateComponent"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {ContentRequest} contentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateContent(campaignId, contentId, contentRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateContent(campaignId, contentId, contentRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ContentControllerApi.updateContent"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    }
  };
};
var ContentControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = ContentControllerApiFp(configuration);
  return {
    /**
     * 
     * @param {string} campaignId 
     * @param {ContentRequest} contentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createContent(campaignId, contentRequest, options) {
      return localVarFp.createContent(campaignId, contentRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {string} componentReference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComponent(campaignId, contentId, componentReference, options) {
      return localVarFp.deleteComponent(campaignId, contentId, componentReference, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteContent(campaignId, contentId, options) {
      return localVarFp.deleteContent(campaignId, contentId, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContent(campaignId, contentId, options) {
      return localVarFp.getContent(campaignId, contentId, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} [lastEvaluatedKey] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContents(campaignId, lastEvaluatedKey, limit, options) {
      return localVarFp.listContents(campaignId, lastEvaluatedKey, limit, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {ComponentRequest} componentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateComponent(campaignId, contentId, componentRequest, options) {
      return localVarFp.updateComponent(campaignId, contentId, componentRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {string} contentId 
     * @param {ContentRequest} contentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContent(campaignId, contentId, contentRequest, options) {
      return localVarFp.updateContent(campaignId, contentId, contentRequest, options).then((request) => request(axios, basePath));
    }
  };
};
var ContentControllerApi = class extends BaseAPI {
  /**
   * 
   * @param {string} campaignId 
   * @param {ContentRequest} contentRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  createContent(campaignId, contentRequest, options) {
    return ContentControllerApiFp(this.configuration).createContent(campaignId, contentRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {string} contentId 
   * @param {string} componentReference 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  deleteComponent(campaignId, contentId, componentReference, options) {
    return ContentControllerApiFp(this.configuration).deleteComponent(campaignId, contentId, componentReference, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {string} contentId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  deleteContent(campaignId, contentId, options) {
    return ContentControllerApiFp(this.configuration).deleteContent(campaignId, contentId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {string} contentId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  getContent(campaignId, contentId, options) {
    return ContentControllerApiFp(this.configuration).getContent(campaignId, contentId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {string} [lastEvaluatedKey] 
   * @param {number} [limit] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  listContents(campaignId, lastEvaluatedKey, limit, options) {
    return ContentControllerApiFp(this.configuration).listContents(campaignId, lastEvaluatedKey, limit, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {string} contentId 
   * @param {ComponentRequest} componentRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  updateComponent(campaignId, contentId, componentRequest, options) {
    return ContentControllerApiFp(this.configuration).updateComponent(campaignId, contentId, componentRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {string} contentId 
   * @param {ContentRequest} contentRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  updateContent(campaignId, contentId, contentRequest, options) {
    return ContentControllerApiFp(this.configuration).updateContent(campaignId, contentId, contentRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var InviteLinkControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {string} campaignId 
     * @param {GenerateInviteLinkRequest} generateInviteLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInviteLink: async (campaignId, generateInviteLinkRequest, options = {}) => {
      assertParamExists("generateInviteLink", "campaignId", campaignId);
      assertParamExists("generateInviteLink", "generateInviteLinkRequest", generateInviteLinkRequest);
      const localVarPath = `/campaign/{campaignId}/invites`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(generateInviteLinkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {ProcessInviteLinkRequest} processInviteLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    processInviteLink: async (campaignId, processInviteLinkRequest, options = {}) => {
      assertParamExists("processInviteLink", "campaignId", campaignId);
      assertParamExists("processInviteLink", "processInviteLinkRequest", processInviteLinkRequest);
      const localVarPath = `/campaign/{campaignId}/invites/process`.replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(processInviteLinkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
var InviteLinkControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = InviteLinkControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {string} campaignId 
     * @param {GenerateInviteLinkRequest} generateInviteLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateInviteLink(campaignId, generateInviteLinkRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.generateInviteLink(campaignId, generateInviteLinkRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["InviteLinkControllerApi.generateInviteLink"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {ProcessInviteLinkRequest} processInviteLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async processInviteLink(campaignId, processInviteLinkRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.processInviteLink(campaignId, processInviteLinkRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["InviteLinkControllerApi.processInviteLink"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    }
  };
};
var InviteLinkControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = InviteLinkControllerApiFp(configuration);
  return {
    /**
     * 
     * @param {string} campaignId 
     * @param {GenerateInviteLinkRequest} generateInviteLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInviteLink(campaignId, generateInviteLinkRequest, options) {
      return localVarFp.generateInviteLink(campaignId, generateInviteLinkRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {string} campaignId 
     * @param {ProcessInviteLinkRequest} processInviteLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    processInviteLink(campaignId, processInviteLinkRequest, options) {
      return localVarFp.processInviteLink(campaignId, processInviteLinkRequest, options).then((request) => request(axios, basePath));
    }
  };
};
var InviteLinkControllerApi = class extends BaseAPI {
  /**
   * 
   * @param {string} campaignId 
   * @param {GenerateInviteLinkRequest} generateInviteLinkRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteLinkControllerApi
   */
  generateInviteLink(campaignId, generateInviteLinkRequest, options) {
    return InviteLinkControllerApiFp(this.configuration).generateInviteLink(campaignId, generateInviteLinkRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} campaignId 
   * @param {ProcessInviteLinkRequest} processInviteLinkRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteLinkControllerApi
   */
  processInviteLink(campaignId, processInviteLinkRequest, options) {
    return InviteLinkControllerApiFp(this.configuration).processInviteLink(campaignId, processInviteLinkRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var ProfileControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {DeleteProfileRequest} deleteProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProfile: async (deleteProfileRequest, options = {}) => {
      assertParamExists("deleteProfile", "deleteProfileRequest", deleteProfileRequest);
      const localVarPath = `/profile`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(deleteProfileRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfile: async (options = {}) => {
      const localVarPath = `/profile`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * 
     * @param {ModifyProfileRequest} modifyProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putProfile: async (modifyProfileRequest, options = {}) => {
      assertParamExists("putProfile", "modifyProfileRequest", modifyProfileRequest);
      const localVarPath = `/profile`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(modifyProfileRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
var ProfileControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = ProfileControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {DeleteProfileRequest} deleteProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteProfile(deleteProfileRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfile(deleteProfileRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ProfileControllerApi.deleteProfile"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProfile(options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ProfileControllerApi.getProfile"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 
     * @param {ModifyProfileRequest} modifyProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putProfile(modifyProfileRequest, options) {
      var _a, _b, _c;
      const localVarAxiosArgs = await localVarAxiosParamCreator.putProfile(modifyProfileRequest, options);
      const localVarOperationServerIndex = (_a = configuration == null ? void 0 : configuration.serverIndex) != null ? _a : 0;
      const localVarOperationServerBasePath = (_c = (_b = operationServerMap["ProfileControllerApi.putProfile"]) == null ? void 0 : _b[localVarOperationServerIndex]) == null ? void 0 : _c.url;
      return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    }
  };
};
var ProfileControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = ProfileControllerApiFp(configuration);
  return {
    /**
     * 
     * @param {DeleteProfileRequest} deleteProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProfile(deleteProfileRequest, options) {
      return localVarFp.deleteProfile(deleteProfileRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfile(options) {
      return localVarFp.getProfile(options).then((request) => request(axios, basePath));
    },
    /**
     * 
     * @param {ModifyProfileRequest} modifyProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putProfile(modifyProfileRequest, options) {
      return localVarFp.putProfile(modifyProfileRequest, options).then((request) => request(axios, basePath));
    }
  };
};
var ProfileControllerApi = class extends BaseAPI {
  /**
   * 
   * @param {DeleteProfileRequest} deleteProfileRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileControllerApi
   */
  deleteProfile(deleteProfileRequest, options) {
    return ProfileControllerApiFp(this.configuration).deleteProfile(deleteProfileRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileControllerApi
   */
  getProfile(options) {
    return ProfileControllerApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {ModifyProfileRequest} modifyProfileRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileControllerApi
   */
  putProfile(modifyProfileRequest, options) {
    return ProfileControllerApiFp(this.configuration).putProfile(modifyProfileRequest, options).then((request) => request(this.axios, this.basePath));
  }
};

// src/configuration.ts
var Configuration = class {
  constructor(param = {}) {
    var _a;
    this.apiKey = param.apiKey;
    this.username = param.username;
    this.password = param.password;
    this.accessToken = param.accessToken;
    this.basePath = param.basePath;
    this.serverIndex = param.serverIndex;
    this.baseOptions = {
      ...param.baseOptions,
      headers: {
        ...(_a = param.baseOptions) == null ? void 0 : _a.headers
      }
    };
    this.formDataCtor = param.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    const jsonMime = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === "application/json-patch+json");
  }
};
export {
  AccessControlTypeEnum,
  CampaignControllerApi,
  CampaignControllerApiAxiosParamCreator,
  CampaignControllerApiFactory,
  CampaignControllerApiFp,
  CampaignDTOActionsEnum,
  CampaignDTORoleEnum,
  CampaignInviteDTORoleEnum,
  ComponentTypeEnum,
  Configuration,
  ContentComponentDTOTypeEnum,
  ContentControllerApi,
  ContentControllerApiAxiosParamCreator,
  ContentControllerApiFactory,
  ContentControllerApiFp,
  ContentDTOActionsEnum,
  ContentDTOContentCategoryEnum,
  ContentPreviewDTOContentCategoryEnum,
  ContentRequestContentCategoryEnum,
  GenerateInviteLinkRequestRoleEnum,
  InviteLinkControllerApi,
  InviteLinkControllerApiAxiosParamCreator,
  InviteLinkControllerApiFactory,
  InviteLinkControllerApiFp,
  LimitedProfileDTORoleEnum,
  LinkInfoTypeEnum,
  MembershipRequestRoleEnum,
  ProfileControllerApi,
  ProfileControllerApiAxiosParamCreator,
  ProfileControllerApiFactory,
  ProfileControllerApiFp,
  ProfileDTORolesEnum,
  ProfileDTOTierEnum,
  QuestDTOStatusEnum
};
